import Header from "./Compartido/Header";
import BrandsSection from "./Compartido/BrandsSection";
import Footer from "./Compartido/Footer";
import Texto from "./Compartido/Texto";
import Hero from "./Compartido/Hero";

const Clientes = (props) => {
    return (
        <>
            <main className="min-h-screen">
                <Header
                    config={props.websgrupo}
                    lang={props.lang}
                    meta_titulo={props.meta_titulo}
                    meta_descripcion={props.meta_descripcion}
                    meta_keywords={props.meta_keywords}
                    ruta={props.ruta}
                    idiomas={props.idiomas}
                    destinos={props.destinos}
                    experiencias={props.experiencias}
                />
                <Hero
                    eltexto={props.textoclientes}
                    ruta={props.ruta}
                    laseccion="Clientes"
                />
                <Texto
                    config={props.websgrupo}
                    ruta={props.ruta}
                    eltexto={props.textoclientes}
                />
            </main>
            <app-footer>
                <BrandsSection
                    lang={props.lang}
                    marcas={props.marcas}
                    ruta={props.ruta}
                />
                <Footer
                    lang={props.lang}
                    config={props.websgrupo}
                />
            </app-footer>


        </>
    );
}

export default Clientes;
